function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.25 1.15234V3.28516H0.703125C0.611979 3.28516 0.529948 3.32161 0.457031 3.39453C0.402344 3.44922 0.375 3.52214 0.375 3.61328V3.88672C0.375 3.97786 0.402344 4.0599 0.457031 4.13281C0.529948 4.1875 0.611979 4.21484 0.703125 4.21484H8.25V6.34766C8.25 6.62109 8.33203 6.83984 8.49609 7.00391C8.67839 7.16797 8.88802 7.25 9.125 7.25C9.36198 7.25 9.57161 7.16797 9.75391 7.00391L12.3789 4.37891C12.543 4.19661 12.625 3.98698 12.625 3.75C12.625 3.51302 12.543 3.30339 12.3789 3.12109L9.75391 0.496094C9.57161 0.332031 9.36198 0.25 9.125 0.25C8.88802 0.25 8.67839 0.332031 8.49609 0.496094C8.33203 0.660156 8.25 0.878906 8.25 1.15234ZM11.75 3.75L9.125 6.375V1.125L11.75 3.75Z",
  fill: "currentColor"
});

var SvgLongArrowAltRight = function SvgLongArrowAltRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLongArrowAltRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/long-arrow-alt-right.06952a5d.svg";
export { ForwardRef as ReactComponent };